import React from 'react';
import {Avatar} from '@gravity-ui/uikit';
import {Message} from '../../../entities/conversation';
import {ConversationAudience} from '../../../entities/conversation/hooks/useConversationMessages';
import styles from './ConversationFeed.module.scss';

interface UserInfo {
  displayName: string;
  avatarUrl: string | null;
}

interface MessageBubbleProps {
  message: Message;
  audience: ConversationAudience;
  usersData: Record<string, UserInfo>;
}

function formatTime(iso: string): string {
  const date = new Date(iso);
  return date.toLocaleString('ru-RU', {day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit'});
}

function getInitials(name: string): string {
  return name
    .split(' ')
    .slice(0, 2)
    .map((w) => w[0])
    .join('')
    .toUpperCase();
}

export const MessageBubble: React.FC<MessageBubbleProps> = ({message, audience, usersData}) => {
  let authorName: string;
  let authorRole: string;
  let avatarUrl: string | null = null;

  if (audience === 'representative') {
    if (message.authorId == null) {
      authorName = 'Администратор НА СТАРТ';
      authorRole = 'Администратор';
    } else {
      const user = usersData[message.authorId];
      authorName = user?.displayName ?? 'Представитель';
      avatarUrl = user?.avatarUrl ?? null;
      authorRole = 'Со-Представитель';
    }
  } else {
    if (message.authorId != null && usersData[message.authorId]) {
      const user = usersData[message.authorId];
      authorName = user.displayName;
      avatarUrl = user.avatarUrl;
      authorRole = message.authorKind === 'Representative' ? 'Представитель' : 'Администратор';
    } else {
      authorName = message.authorKind === 'Representative' ? 'Представитель' : 'Администратор';
      authorRole = message.authorKind;
    }
  }

  return (
    <div className={styles.fi}>
      <Avatar
        text={getInitials(authorName)}
        imgUrl={avatarUrl ?? undefined}
        size="m"
      />
      <div className={styles.fiBody}>
        <div className={styles.fiHead}>
          <span className={styles.fiName}>{authorName}</span>
          <span className={styles.fiTime}>{formatTime(message.createdAt)}</span>
        </div>
        <div className={styles.fiRole}>{authorRole}</div>
        <div className={styles.fiText}>{message.text}</div>
      </div>
    </div>
  );
};
